import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/models/octavia/comfort",
  "description": "ŠKODA OCTAVIA знает, как позаботиться о водителе и пассажирах. Множество опций позволят вам получать ещё больше удовольствия от каждой поездки. Подробный обзор автомобиля, фото, технические характеристики, комплектации  на официальном сайте ŠKODA в России.",
  "huggerTemplate": "default",
  "keywords": "Skoda Octavia Comfort",
  "name": "octavia-comfort",
  "title": "Комфорт ŠKODA OCTAVIA | Умные решения Simply Clever и системы помощи водителю в новой Шкода Октавия 2023/2022 в Шкода Октавия - официальный сайт ŠKODA в России"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const ShowRoomTextBlock = makeShortcode("ShowRoomTextBlock");
const ShowRoomTextBlockTitle = makeShortcode("ShowRoomTextBlockTitle");
const ShowRoomTextBlockText = makeShortcode("ShowRoomTextBlockText");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const Slider = makeShortcode("Slider");
const SlideIcon = makeShortcode("SlideIcon");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="bottom" horizontalAlign="left" src="/m/octavia-comfort-kv-new.jpg" mobileSrc="/m/octavia-comfort-kv-mob-new.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading">ХАЙ-ТЕК-КОМФОРТ</SimpleMainStageHeading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionText mdxType="DefaultSectionText">
    OCTAVIA знает, как позаботиться о водителе и пассажирах. Для автомобиля
    предлагается множество опций, которые позволят вам и вашим близким получать
    ещё больше удовольствия от каждой поездки. Улучшить себе настроение на годы
    вперёд очень просто — просто надо выбрать машину в правильной комплектации.
    Не стоит экономить на собственном комфорте.
  </DefaultSectionText>
  <FeaturesSliderQueried tags="octavia2020-comfortpage-simply-clever" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <ShowRoomTextBlock desktopPic="/m/new-octavia-control-new.jpg" mobilePic="/m/new-octavia-control-mob.jpg" model="octavia" alignRight mdxType="ShowRoomTextBlock">
  <ShowRoomTextBlockTitle mdxType="ShowRoomTextBlockTitle">Адаптивный круиз-контроль</ShowRoomTextBlockTitle>
  <ShowRoomTextBlockText main key="main" mdxType="ShowRoomTextBlockText">
    Эта радарная система позволяет проехать десятки километров по трассе, не
    прикасаясь к педалям тормоза и газа. OCTAVIA сама будет ускоряться в
    пределах установленного лимита (максимум — 210 км/ч), поддерживать заданную
    водителем дистанцию и притормаживать по мере необходимости. Система
    сочетается с автоматическими и механическими коробками передач. Позволяет
    совершать обгоны/опережения, не сбивая настроек. Автомобиль с ACC может не
    только самостоятельно тормозить, но и трогаться после короткой (в пределах
    трёх секунд) остановки. Радар, даже когда система не активна, следит за
    дистанцией — готов предупредить водителя об опасности или инициировать
    экстренное торможение. Заметим, что такая система контроля дистанции,
    называемая Front Assist, доступна ещё и в виде отдельной опции, без блока
    адаптивного круиз-контроля.
  </ShowRoomTextBlockText>
    </ShowRoomTextBlock>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">OCTAVIA ПЛЮС</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    ŠKODA OCTAVIA обладает многими достоинствами. Это вместительный, комфортный,
    безопасный, практичный и красивый автомобиль. Оригинальные аксессуары
    позволяют приумножить перечисленные выше качества. Все предлагаемые товары
    отличаются высоким качеством, идеально подходят к машине и прослужат долгое
    время.
  </DefaultSectionText>
  <FeaturesSliderQueried tags="octavia2020-comfortpage-parking" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" noPt mdxType="DefaultPaddedSection">
  <Slider slidesToShow={1} mdxType="Slider">
    <SlideIcon key="/m/subscribe.svg" icon="/m/subscribe.svg" title="Подписаться" text=" Подпишитесь на новости о ŠKODA" buttonText="Подписаться на новости" buttonLink="/subscribe" mdxType="SlideIcon" />
  </Slider>
    </DefaultPaddedSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      